import * as S from "../../Style/Page/Car.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitleCar.js";
import HatPageTopLine from "../../Component/CarPageTopLine.js";
// const FactoryImg1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/31. 중국계림법인.32bfe3a5edcf7a0e7dc3.png`;
import FactoryImg1 from "../../assets/BusBusiness/계림공장.png";
const Bus1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/32. 중국계림법인 GL6128HK.c679c189e8117cec786a.png`;
// const Bus4 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/35 중국계림법인 GDW6900HK.2822c982bdb1570e8c5f.png`;
// const Bus5 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/36. 중국계림법인 GDW6126HG.7519bc4b5341276de395.png`;
import Bus5 from "../../assets/BusBusiness/GDW6121.png";
// const Bus8 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/39. 중국계림법인 GDW6110HG.e1d1d869e16e8f131ffe.png`;
import Bus8 from "../../assets/BusBusiness/KD생산.png";
import Bus4 from "../../assets/BusBusiness/부품소싱.png";
const FactoryInner = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/사진 12.16c00cdf895c28df6fdf.jpg`;
const Factory3 = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"상용버스사업"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <Link to="/BusBusiness/OverseasBus">
                <div className="kor">버스사업</div>
                <div className="eng">Bus Business</div>
              </Link>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">Fork Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"156px"}>
          <S.NavItem>
              <Link to="/BusBusiness/Factory">
                <div className="kor">생산공장</div>
                <div className="eng">production plant</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">해외 상용버스사업</div>
                  <div className="eng">Overseas commercial bus business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory">
                  <div className="kor">생산공장</div>
                  <div className="eng">production plant</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/BusBusinessHistory">
                  <div className="kor">버스사업이력</div>
                  <div className="eng">Major business history</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"312px"}>
            <S.NavItem>
              <Link to="/BusBusiness/Factory3">
                <div className="kor">중국 계림 법인</div>
                <div className="eng">China Production Plant</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory">
                  <div className="kor">베트남 생산공장</div>
                  <div className="eng">Vietnam Production Plant</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory2">
                  <div className="kor">베트남 부품공장</div>
                  <div className="eng">Vietnam Parts Manufacturing</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory3">
                  <div className="kor">중국 계림 법인</div>
                  <div className="eng">China Production Plant</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory4">
                  <div className="kor">파키스탄 공장</div>
                  <div className="eng">Pakistan Production Plant</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory5">
                  <div className="kor">카자흐스탄 공장</div>
                  <div className="eng">Kazakhstan Production Plant</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory6">
                  <div className="kor">코스타리카 법인</div>
                  <div className="eng">Costa Rica Sales Corporation</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>
        <div className="wrap">
          <div className="inner">
            <PageTitle
              titleko={"중국 계림 법인"}
              titleeng={"Production Plant"}
              website={"http://www.gldaewoo.com/"}
            />
            <div className="page-text"><h2>Guilin Daewoo Bus Co., Ltd. </h2></div>
            <S.ImgHolderFullsize>
              <img src={FactoryImg1} className="holder-img" alt="" />
              <div className="holder-name">
              <div className="kor">계림 공장</div>
              <div className="eng">Guilin Daewoo Bus</div>
              </div>
            </S.ImgHolderFullsize>

            <PageTitle titleko={"공장 내부 / 주요 생산 / 판매차종"} titleeng={"Factory Interior / Major Product / Sales model"} />
            <S.ImgHolderFlex className="start">
              <S.ImgHolderHarf>
                <img src={FactoryInner} className="holder-img" alt="" />
                <div className="holder-name">
                <div className="kor">공장 내부</div>
                <div className="eng">Factory Interior</div>
                </div>
              </S.ImgHolderHarf>
              <div className="sale-bus-list flex-right">
                <div className="sale-bus-item">
                  <img src={Bus1} alt="" className="sale-bus-img" />
                  <div className="sale-bus-name">GL6128</div>
                </div>
                <div className="sale-bus-item">
                  <img src={Bus5} alt="" className="sale-bus-img" />
                  <div className="sale-bus-name">GDW6121</div>
                </div>
                <div className="sale-bus-item">
                  <img src={Bus8} alt="" className="sale-bus-img" />
                  <div className="sale-bus-name">
                    <div className="kor">KD생산</div>
                    <div className="eng">KD Assembly</div>
                  </div>
                </div>
                

                <div className="sale-bus-item">
                  <img src={Bus4} alt="" className="sale-bus-img" />
                  <div className="sale-bus-name">
                    <div className="kor">부품소싱</div>
                    <div className="eng">Parts Sourcing</div>
                  </div>
                </div>
              </div>
            </S.ImgHolderFlex>

            <PageTitle titleko={"주요 이력"} titleeng={"Key History"} />
            <div className="page-text">
              <div className="page-text-flex">
                <div className="page-text-area">
                  <div className="page-text-title">
                    <div className="kor">Guilin Daewoo Bus Co., Ltd. 법인개요</div>
                    <div className="eng">Guilin Daewoo Bus Co., Ltd. Status</div>
                  </div>
                  <div className="kor">법인 설립: 1994년 3월 22일 (자일자동차 50% / 계림객차 50%)</div>
                  <div className="eng">established: 1994. 3. 22 (Zyle 50% / Guilin Bus 50%)</div>
                </div>
              </div>
              <div className="kor">
                ※ 공장규모: 부지 36,839평 / 건물 22,859평 <br />
                ※ 연간 생산능력: 1,000대(8T 기준)
                <br />
                ※ 중대형 버스 및 부품, KD 생산/판매
                <br />
              </div>
              <div className="eng">
                ※ Factory Size: land 121,800 square meters / building 75,600 square meters
                <br />
                ※ Annual production capa: 1,000 units(8T basis)
                <br />
                ※ Mid & Large bus & parts, KD manufacturing / sales
              </div>
            </div>
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default Factory3;
